export const SET_LOADING = 'SET_LOADING'
export const SET_EXPORTERS = 'SET_EXPORTERS'
export const UPDATE_EXPORTER = 'SET_EXPORTER'

export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS'
